export default function enquiryForm() {
  const selectEls = document.querySelectorAll(
    'select[name="enquiry_form_location"]',
  );

  if (selectEls.length > 0) {
    selectEls.forEach((el) => {
      const module = el.closest(".module");
      el.addEventListener("change", () => {
        if (el.value == "show-form") {
          module.querySelector(
            ".js-tripleseat-button-container",
          ).style.display = "none";

          module.querySelector(".js-enquiry-form-container").style.display =
            "block";
        } else {
          module.querySelector(
            ".js-tripleseat-button-container",
          ).style.display = "block";

          module
            .querySelector(".js-tripleseat-button-container .button-circled")
            .setAttribute("href", el.value);

          window.open(el.value, "_blank");

          module.querySelector(".js-enquiry-form-container").style.display =
            "none";
        }
      });
    });
  }
}
